/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PeriodicNotificationCreate = {
    properties: {
        data: {
            type: 'dictionary',
            contains: {
                type: 'string',
            },
            isRequired: true,
        },
        dayOfTheWeek: {
            type: 'number',
            description: `Day of the week where 1 is Monday and 7 is Sunday`,
            isRequired: true,
        },
        hour: {
            type: 'number',
            description: `Hour of the day in UTC`,
            isRequired: true,
            maximum: 23,
        },
        active: {
            type: 'boolean',
            isRequired: true,
        },
        title: {
            type: 'TranslationCreate',
            isRequired: true,
        },
        body: {
            type: 'TranslationCreate',
            isRequired: true,
        },
        areaOfInterestId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
